import { useState, useEffect } from "react";
import { Timer } from "lucide-react";

export default function Countdown({ targetIso, prefix = "Rappel dans" }) {
  const [msLeft, setMsLeft] = useState(() => diff(targetIso));

  useEffect(() => {
    const id = setInterval(() => setMsLeft(diff(targetIso)), 1000);
    return () => clearInterval(id);
  }, [targetIso]);

  const overdue = msLeft <= 0;

  return (
    <span
      className="inline-flex items-center gap-1.5"
      data-testid="countdown"
      data-overdue={overdue ? "true" : "false"}
    >
      <Timer size={12} />
      {overdue ? "Rappel échu" : `${prefix} ${formatMs(msLeft)}`}
    </span>
  );
}

function diff(iso) {
  if (!iso) return 0;
  return new Date(iso).getTime() - Date.now();
}

function formatMs(ms) {
  const totalSec = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h}h${String(m).padStart(2, "0")}`;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
